import React from "react";
import { useConfirmationStore } from "./stores/confirmationStore";

// Компонент вікна підтвердження
const ConfirmationModal = () => {
  const { isVisible, title, message, handleConfirm, hideConfirmation } =
    useConfirmationStore();

  if (!isVisible) {
    return null;
  }

  return (
    <div className="modal-backdrop">
      <div className="confirmation-modal">
        <h4 className="modal-title">{title}</h4>
        <p className="modal-message">{message}</p>
        <div className="modal-actions">
          <button className="confirm-button focus-button" onClick={handleConfirm}>
            Так, підтвердити
          </button>
          <button className="cancel-button" onClick={hideConfirmation}>
            Скасувати
          </button>
        </div>
      </div>
    </div>
  );
};

export default ConfirmationModal;
